//ACCORDION CONTENT
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.icon');

      // Toggle the current item
      if (content.classList.contains('open')) {
          content.classList.remove('open');
          icon.textContent = '+';
      } else {
          // Close all other items
          document.querySelectorAll('.accordion-content').forEach(c => {
              c.classList.remove('open');
              c.previousElementSibling.querySelector('.icon').textContent = '+';
          });

          // Open the current item
          content.classList.add('open');
          icon.textContent = '-';
      }
  });
});